import React from "react";
import { AdvancedSearchHeader } from "./AdvancedSearchHeader";
import { AdvancedSearchGenres } from "./AdvancedSearchGenres";
import { AdvancedSearchReadingLists } from "./AdvancedSearchReadingLists";
import { AdvancedSearchReadingLevels } from "./AdvancedSearchReadingLevels";
import { AdvancedSearchFormats } from "./AdvancedSearchFormats";

/**
 * Renderiza la versión de escritorio del menú de búsqueda avanzada.
 *
 * Este componente organiza las diferentes secciones de filtros disponibles
 * (géneros, listas de lectura, niveles de lectura y formatos), además de
 * mostrar el encabezado de la búsqueda avanzada.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textos - Objeto con los textos e internacionalización de la interfaz.
 * @param {Object} props.data - Datos utilizados para construir las opciones de los filtros.
 * @param {Function} props.onClose - Función que cierra el menú de búsqueda avanzada.
 * @returns {JSX.Element} Menú de búsqueda avanzada para dispositivos de escritorio.
 */
export const AdvancedSearchDesktop = ({
    textos,
    data,
    onClose,
}) => {
    return (
        <section className="menu">
            <div className="content px-4 pb-4">
                <AdvancedSearchHeader
                    textos={textos}
                />

                <div className="d-lg-flex main-section">
                    <div className="col-5">
                        <AdvancedSearchGenres
                            textos={textos}
                            data={data}
                            onClose={onClose}
                        />
                    </div>

                    <div className="col-3">
                        <AdvancedSearchReadingLists
                            textos={textos}
                            data={data}
                            onClose={onClose}
                        />
                    </div>

                    <div className="col-4">
                        <AdvancedSearchReadingLevels
                            textos={textos}
                            data={data}
                            onClose={onClose}
                        />
                    </div>
                </div>

                {/* <AdvancedSearchFormats
                    textos={textos}
                    onClose={onClose}
                /> */}
            </div>
        </section>
    );
};